import React, { useRef, useState } from 'react'

import { getUUID } from '../../utils/code-editor'
import { useEditorConfig, useMessageListener, useParentValue } from './CodeEditor.hooks'
import { CodeEditorProps } from './CodeEditor.types'

export const CodeEditor = (props: CodeEditorProps) => {
  const ref = useRef<HTMLIFrameElement>(null)
  const [editorId] = useState(getUUID())
  useParentValue(editorId, ref, props.parentValue)
  const config = useEditorConfig(editorId, ref, props)

  useMessageListener({
    editorId,
    ref,
    config,
    props,
  })

  return (
    <iframe
      width="100%"
      height="100%"
      title={`Editor_${editorId}`}
      src={`/editor.html?editorId=${editorId}`}
      ref={ref}
    />
  )
}
